import { roadB05 } from "../../utils/ROADS/roadB05";
import RoadMapGeneric from "../../components/Roadmaps/RoadMapGeneric";

const RoadMapB05 = (props) => <RoadMapGeneric {...props} roadData={roadB05} />;
export default RoadMapB05;